import { useCssVars as _useCssVars, mergeDefaults as _mergeDefaults, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "io-hero-wrapper" }
const _hoisted_2 = { class: "io-hero__container" }
const _hoisted_3 = { class: "io-hero__container__content" }
const _hoisted_4 = { class: "io-hero__headline-row" }
const _hoisted_5 = { class: "io-hero__headline-row__icon" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "io-hero__background" }
const _hoisted_8 = { class: "container-fluid" }
const _hoisted_9 = { class: "position-relative" }
const _hoisted_10 = { class: "io-hero__disruptor__content" }

import BaseButton from '@/components/BaseButton.vue';
import IoWave from '@/components/IoWave.vue';
import Observer from '@/components/Observer.vue';
import { HeroPropsDefaults, HeroPropsInterface } from '@/data/Hero';
import { getRandomId } from '@/helpers';
import {
  reactive,
  computed,
  onMounted,
  onBeforeUnmount,
  ref,
  watch,
  nextTick,
  useSlots, inject, Ref,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Hero',
  props: /*#__PURE__*/_mergeDefaults({
    contentAlign: {},
    height: {},
    mediaId: {},
    mediaType: {},
    mediaSizes: {},
    mediaAlt: {},
    mediaUrl: {},
    previewMediaId: {},
    previewMediaType: {},
    previewMediaSizes: {},
    previewMediaAlt: {},
    previewMediaUrl: {},
    backgroundPositionY: {},
    backgroundPositionX: {},
    mediaIdDesktop: {},
    mediaTypeDesktop: {},
    mediaSizesDesktop: {},
    mediaAltDesktop: {},
    mediaUrlDesktop: {},
    previewMediaIdDesktop: {},
    previewMediaTypeDesktop: {},
    previewMediaSizesDesktop: {},
    previewMediaAltDesktop: {},
    previewMediaUrlDesktop: {},
    backgroundPositionYDesktop: {},
    backgroundPositionXDesktop: {},
    iconMediaId: {},
    iconMediaType: {},
    iconMediaSizes: {},
    iconMediaAlt: {},
    iconMediaUrl: {},
    fontColor: {},
    colorGradient: {},
    pageUrl: {},
    pageUrlLabel: {},
    calculatorShow: {},
    isBusinessActive: {},
    calculatorBranches: {},
    calculatorLabelExtra: {},
    disruptorBackground: {}
  }, HeroPropsDefaults),
  setup(__props: any) {

_useCssVars(_ctx => ({
  "0370d042": (disruptorMaskUrl),
  "6208e4b8": (disruptorMaskSvgUrl)
}))

const props = __props;

const slots = useSlots();
const header = reactive({
  $el: null as null | HTMLElement,
});
const heroContainer = ref<InstanceType<typeof HTMLElement>>();
const root = ref<InstanceType<typeof HTMLElement>>();
const background = ref<InstanceType<typeof LazyBackgroundMedia>>();
const calculatorComponent = ref();
const isMobileBreakpoint = inject('isMobileBreakpoint') as Ref<boolean>;
const currentPreviewMedia = computed<Record<symbol, unknown>>(() => ({
  id: isMobileBreakpoint.value ? props.previewMediaId : (props.previewMediaIdDesktop || props.previewMediaId),
  type: isMobileBreakpoint.value ? props.previewMediaType : (props.previewMediaTypeDesktop || props.previewMediaType),
  sizes: isMobileBreakpoint.value ? props.previewMediaSizes : (props.previewMediaSizesDesktop || props.previewMediaSizes),
  alt: isMobileBreakpoint.value ? props.previewMediaAlt : (props.previewMediaAltDesktop || props.previewMediaAlt),
  url: isMobileBreakpoint.value ? props.previewMediaUrl : (props.previewMediaUrlDesktop || props.previewMediaUrl),
}));
const currentIconMedia = computed<Record<symbol, unknown>>(() => ({
  id: props.iconMediaId,
  type: props.iconMediaType,
  sizes: props.iconMediaSizes,
  alt: props.iconMediaAlt,
  url: props.iconMediaUrl,
  positionX: 'center',
  positionY: 'center',
}));
const hasIcon = computed<boolean>(() => ![undefined, null, 0, '0', ''].includes(currentIconMedia.value.id || 0));

const subline = slots.subline ? slots.subline() : undefined;
const hasSubline = computed(() => (
  subline && subline[0] ? `${subline[0].children}`.trim().length > 0 : false
));
const content = slots.content ? slots.content() : undefined;
const hasContent = computed(() => (
  content && content[0] ? `${content[0].children}`.trim().length > 0 : false
));

const disruptor = slots.disruptor ? slots.disruptor() : undefined;
const hasDisruptor = computed(() => (
  disruptor && disruptor[0] ? `${disruptor[0].children}`.trim().length > 0 : false
));

const minHeight = ref<number | null>(null);

const setMinHeight = () => {
  minHeight.value = null;
  let headerHeight = 0;

  if (header.$el) {
    headerHeight = header.$el.offsetHeight;
  }

  switch (props.height) {
    case 'full':
      minHeight.value = window.innerHeight - headerHeight;
      break;
    case 'small':
      minHeight.value = (window.innerHeight - headerHeight) * 0.537037;
      break;
    case 'auto':
      minHeight.value = 0;
      break;
    default:
      minHeight.value = (window.innerHeight - headerHeight) * 0.7407407;
  }
};

const resizeHandler = () => {
  setMinHeight();
};

const heroClasses = [
  'io-hero',
  `text-${props.fontColor}`,
];

const disruptorWave = ref<InstanceType<typeof IoWave>>();
const disruptorWaveObserver = ref<InstanceType<typeof Observer>>();
const disruptorWrapper = ref<HTMLElement>();
const disruptorSvgMaskUrl = `${window.ioappConfig.themeUri}/public/img/wave/WelleNegativGespiegelt.svg`;
const disruptorWaveId = getRandomId('wave-');
const disruptorMaskUrl = `url(#${disruptorWaveId})`;
const disruptorMaskSvgUrl = `url('${disruptorSvgMaskUrl}')`;
const disruptorStyles = ref<Record<string, string>>({});

const onDisruptorWaveResize = ({ height }: Record<string, number | undefined>) => {
  disruptorStyles.value.marginTop = '0px';

  if (!isMobileBreakpoint.value) return;

  disruptorStyles.value.marginTop = `-${height || 0}px`;
};
const resizeDisruptor = () => {
  disruptorStyles.value.marginTop = '0px';

  if (!disruptorWrapper.value) return;

  if (isMobileBreakpoint.value) {
    disruptorWrapper.value.style.removeProperty('height');
    disruptorWrapper.value.style.removeProperty('width');
    disruptorWrapper.value.style.removeProperty('height');
    disruptorWrapper.value.style.removeProperty('--app-disruptor-padding-x');
    disruptorWrapper.value.style.removeProperty('--app-disruptor-padding-y');

    disruptorWaveObserver.value?.setRootSize();

    return;
  }

  let bestWidthFound = false;
  let widthToTest = 180;
  let lastDiff = 9999999999999;
  let lastWidth = widthToTest;
  let lastHeight = 0;

  while (!bestWidthFound) {
    disruptorWrapper.value.style.setProperty('height', 'auto');
    disruptorWrapper.value.style.setProperty('width', `${widthToTest}px`);
    disruptorWrapper.value.style.setProperty('--app-disruptor-padding-x', `${widthToTest * 0.10}px`);
    disruptorWrapper.value.style.setProperty('--app-disruptor-padding-y', `${widthToTest * 0.17}px`);

    const curHeight = disruptorWrapper.value.offsetHeight;
    const curDiff = Math.abs(widthToTest - curHeight);

    if (curDiff < lastDiff) {
      lastWidth = widthToTest;
      lastHeight = curHeight;
      widthToTest += 20;
      lastDiff = curDiff;
    } else {
      const sizeToUse = lastWidth > lastHeight ? lastWidth : lastHeight;
      disruptorWrapper.value.style.setProperty('height', `${sizeToUse}px`);
      disruptorWrapper.value.style.setProperty('width', `${sizeToUse}px`);
      disruptorWrapper.value.style.setProperty('--app-disruptor-padding-x', `${sizeToUse * 0.10}px`);
      disruptorWrapper.value.style.setProperty('--app-disruptor-padding-y', `${sizeToUse * 0.17}px`);
      bestWidthFound = true;
    }
  }
};

onMounted(() => {
  header.$el = document.querySelector('header');
  window.addEventListener('resize', resizeHandler);
  window.addEventListener('load', resizeHandler);
  resizeHandler();

  if (hasDisruptor.value) {
    window.addEventListener('resize', resizeDisruptor);
    window.addEventListener('load', resizeDisruptor);
    resizeDisruptor();
  }

  for (let i = 100; i < 1000; i += 100) {
    setTimeout(resizeHandler, i);

    if (hasDisruptor.value) {
      setTimeout(resizeDisruptor, i);
    }
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', resizeHandler);
  window.removeEventListener('load', resizeHandler);

  if (hasDisruptor.value) {
    window.removeEventListener('resize', resizeDisruptor);
    window.removeEventListener('load', resizeDisruptor);
  }
});

watch(() => calculatorComponent.value, () => {
  nextTick(resizeHandler);
});

return (_ctx: any,_cache: any) => {
  const _component_LazyBackgroundMedia = _resolveComponent("LazyBackgroundMedia")!
  const _component_IoHeadline = _resolveComponent("IoHeadline")!
  const _component_BaseCalculator = _resolveComponent("BaseCalculator")!
  const _component_BaseGridCol = _resolveComponent("BaseGridCol")!
  const _component_BaseGridRow = _resolveComponent("BaseGridRow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "root",
      ref: root,
      class: _normalizeClass(heroClasses)
    }, [
      _createVNode(_component_BaseGridRow, {
        class: "position-relative",
        "min-height": minHeight.value,
        "no-gap": "",
        "vertical-center": _ctx.contentAlign === 'center',
        "vertical-end": _ctx.contentAlign === 'end'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BaseGridCol, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: "container-fluid",
                  ref_key: "heroContainer",
                  ref: heroContainer
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        (hasIcon.value)
                          ? (_openBlock(), _createBlock(_component_LazyBackgroundMedia, {
                              key: `hero-media-${currentIconMedia.value.id}`,
                              "media-id": currentIconMedia.value.id,
                              "media-type": currentIconMedia.value.type,
                              "media-url": currentIconMedia.value.url,
                              "background-position-y": currentIconMedia.value.positionY,
                              "background-position-x": currentIconMedia.value.positionX,
                              immediate: ""
                            }, null, 8, ["media-id", "media-type", "media-url", "background-position-y", "background-position-x"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_IoHeadline, {
                          size: "h1",
                          "text-align": "start",
                          color: _ctx.fontColor
                        }, {
                          default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "headline")
                          ]),
                          _: 3
                        }, 8, ["color"])
                      ])
                    ]),
                    (hasSubline.value)
                      ? (_openBlock(), _createBlock(_component_IoHeadline, {
                          key: 0,
                          size: "h1",
                          "tag-name": "h2",
                          "text-align": "start",
                          color: _ctx.fontColor
                        }, {
                          default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "subline")
                          ]),
                          _: 3
                        }, 8, ["color"]))
                      : _createCommentVNode("", true),
                    (hasContent.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["io-hero__content", `color-${_ctx.fontColor}`])
                        }, [
                          _renderSlot(_ctx.$slots, "content")
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.pageUrl)
                      ? (_openBlock(), _createBlock(BaseButton, {
                          key: 2,
                          "page-url": _ctx.pageUrl,
                          color: _ctx.fontColor,
                          "link-type": "page",
                          type: "outline",
                          align: "start"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", { innerHTML: _ctx.pageUrlLabel }, null, 8, _hoisted_6)
                          ]),
                          _: 1
                        }, 8, ["page-url", "color"]))
                      : _createCommentVNode("", true),
                    (_ctx.calculatorShow === 'true')
                      ? (_openBlock(), _createBlock(_component_BaseCalculator, {
                          key: 3,
                          ref_key: "calculatorComponent",
                          ref: calculatorComponent,
                          "label-extra": _ctx.calculatorLabelExtra,
                          branches: _ctx.calculatorBranches,
                          "show-valid-checks": true,
                          "is-business-active": _ctx.isBusinessActive
                        }, null, 8, ["label-extra", "branches", "is-business-active"]))
                      : _createCommentVNode("", true)
                  ])
                ], 512)
              ])
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["min-height", "vertical-center", "vertical-end"]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_LazyBackgroundMedia, {
          ref_key: "background",
          ref: background,
          class: "io-hero__background-media",
          "media-id": _ctx.mediaId,
          "media-url": _ctx.mediaUrl,
          "media-id-desktop": _ctx.mediaIdDesktop,
          "media-url-desktop": _ctx.mediaUrlDesktop,
          "background-position-y": _ctx.backgroundPositionY,
          "background-position-x": _ctx.backgroundPositionX,
          "background-position-y-desktop": _ctx.backgroundPositionYDesktop,
          "background-position-x-desktop": _ctx.backgroundPositionXDesktop,
          "preview-media-url": currentPreviewMedia.value.url,
          immediate: ""
        }, null, 8, ["media-id", "media-url", "media-id-desktop", "media-url-desktop", "background-position-y", "background-position-x", "background-position-y-desktop", "background-position-x-desktop", "preview-media-url"]),
        _createElementVNode("div", {
          class: _normalizeClass(["io-hero__background-overlay fadeout", {
              [`app-bg-${_ctx.colorGradient}`]: true,
              'to-bottom': _unref(isMobileBreakpoint)
            }])
        }, null, 2)
      ])
    ], 512),
    (hasDisruptor.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["io-hero__disruptor", {
          'is-mobile': _unref(isMobileBreakpoint),
          [`app-bg--${_ctx.disruptorBackground}`]: true,
        }]),
          style: _normalizeStyle(disruptorStyles.value)
        }, [
          _createVNode(Observer, {
            ref_key: "disruptorWaveObserver",
            ref: disruptorWaveObserver,
            onResize: onDisruptorWaveResize
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(IoWave, {
                ref_key: "disruptorWave",
                ref: disruptorWave,
                class: "disruptor-wave",
                "mask-id": _unref(disruptorWaveId),
                "wave-type": "wave",
                "wave-mirrored": true,
                "wave-negative": true
              }, null, 8, ["mask-id"]), [
                [_vShow, _unref(isMobileBreakpoint)]
              ])
            ]),
            _: 1
          }, 512),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                ref_key: "disruptorWrapper",
                ref: disruptorWrapper,
                class: _normalizeClass(["io-hero__disruptor__content-wrapper", `app-bg-${_ctx.disruptorBackground} gradient`])
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _renderSlot(_ctx.$slots, "disruptor")
                ])
              ], 2)
            ])
          ])
        ], 6))
      : _createCommentVNode("", true)
  ]))
}
}

})